import { render } from "./ProjectOneBtoIcon.vue?vue&type=template&id=fe53b1ea"
import script from "./ProjectOneBtoIcon.vue?vue&type=script&lang=js"
export * from "./ProjectOneBtoIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__